import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

// 花名册列表（keyword/groupId/serviceAreaCode/page/pageSize，page 从 1 起）
export const getRosterList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/manage_engineer_roster/list?` + params,
        method: 'GET'
    })
}

// 花名册修改分组和/或接单区域（groupId 与 serviceAreas 不可同时缺省）
export const updateRoster = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/manage_engineer_roster/update`,
        method: 'PUT',
        data: data
    })
}

// 省市区三级字典（复用 joins-basic 行政区划接口）
export const findProvince = () => {
    return request({
        url: `${baseUrl}/joins-basic/v1/province`,
        method: 'GET'
    })
}
export const findCitys = (id) => {
    return request({
        url: `${baseUrl}/joins-basic/v1/province/citys/${id}`,
        method: 'GET'
    })
}
export const findAreas = (id) => {
    return request({
        url: `${baseUrl}/joins-basic/v1/province/areas/${id}`,
        method: 'GET'
    })
}
